import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {
    backgroundColor = "backgroundColor",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.backgroundColor]: string;
    };
}

export interface FooterStripeStyles {
    wrapperStyles?: InjectableCss;
}

export const footerStripeStyles: FooterStripeStyles = {
    wrapperStyles: {
        css: css`
            padding: 64px 64px;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 32px 32px;
                    `,
                    css`
                        padding: 32px 32px;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
};

type Props = OwnProps;

const FooterStripe: React.FC<Props> = ({ fields, id }) => {
    const styles = footerStripeStyles;

    return (
        <StyledWrapper {...styles.wrapperStyles} style={{ background: fields.backgroundColor }}>
            <Zone zoneName="ftr" contentId={id} />
        </StyledWrapper>
    );
};

const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};

const footerStripe: WidgetModule = {
    component: FooterStripe,
    definition: {
        group: "Footer",
        displayName: "NISFooterStripe",
        fieldDefinitions: [
            {
                name: fields.backgroundColor,
                fieldType: "General",
                editorTemplate: "ColorPickerField",
                defaultValue: "#266B40",
                displayName: "Background Color",
            },
        ],
    },
};

export default footerStripe;
